import { render, staticRenderFns } from "./transaction.vue?vue&type=template&id=29919b85&scoped=true&"
import script from "./transaction.vue?vue&type=script&lang=js&"
export * from "./transaction.vue?vue&type=script&lang=js&"
import style0 from "./transaction.vue?vue&type=style&index=0&id=29919b85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29919b85",
  null
  
)

export default component.exports